export type Question = {
  questionPrefix: string;
  category: 'CREATION' | 'PAYMENT_DELIVERY' | 'ADJUST_CANCEL' | 'CONTACT';
  paragraphs: Paragraph[];
};

export type Paragraph = {
  numberSteps: number;
};

export const questions: Question[] = [
  { questionPrefix: 'faq.mov', category: 'CREATION', paragraphs: [] },
  { questionPrefix: 'faq.find', category: 'CREATION', paragraphs: [] },
  {
    questionPrefix: 'faq.setup',
    category: 'CREATION',
    paragraphs: [{ numberSteps: 4 }, { numberSteps: 0 }, { numberSteps: 0 }],
  },
  {
    questionPrefix: 'faq.items',
    category: 'CREATION',
    paragraphs: [{ numberSteps: 0 }, { numberSteps: 0 }],
  },
  {
    questionPrefix: 'faq.pay',
    category: 'PAYMENT_DELIVERY',
    paragraphs: [{ numberSteps: 0 }, { numberSteps: 0 }],
  },
  { questionPrefix: 'faq.costs', category: 'PAYMENT_DELIVERY', paragraphs: [] },
  { questionPrefix: 'faq.notification', category: 'PAYMENT_DELIVERY', paragraphs: [] },
  {
    questionPrefix: 'faq.changes',
    category: 'ADJUST_CANCEL',
    paragraphs: [{ numberSteps: 0 }, { numberSteps: 7 }, { numberSteps: 4 }, { numberSteps: 0 }],
  },
  {
    questionPrefix: 'faq.add-products',
    category: 'ADJUST_CANCEL',
    paragraphs: [{ numberSteps: 0 }, { numberSteps: 7 }],
  },
  { questionPrefix: 'faq.last-date', category: 'ADJUST_CANCEL', paragraphs: [] },
  { questionPrefix: 'faq.article-not-available', category: 'ADJUST_CANCEL', paragraphs: [] },
  { questionPrefix: 'faq.cancel', category: 'ADJUST_CANCEL', paragraphs: [] },
  { questionPrefix: 'faq.contact', category: 'CONTACT', paragraphs: [] },
  { questionPrefix: 'faq.terms', category: 'CONTACT', paragraphs: [] },
];
